<div class="component-container power-connection-container">
  <form [formGroup]="powerConnectionFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-font-size">
    <app-review-section
      #powerConnectionSection
      [title]="powerConnectionHeaderTranslationKey | translate"
      [tooltip]="'tooltips.technician-form.power-connection' | translate"
      [showTooltip]="infoBubblesData?.showPowerSupplyInfo"
      [sectionId]="sectionIdentifier.TechnicalData_BaseData_Power"
      [applicationId]="applicationId"
      [isDetailsView]="isDetailsView"
      (onSectionReviewCreated)="onPowerConnectionReviewSet.emit($event)">
      <div class="form-background form-section">
        <div class="ui-g-12 form-rows">
          <div class="ui-g-6 field-rows" *ngIf="powerConnectionFG.get('totalOutput')">
            <label
              for="power-connection-total-output"
              class="ui-g-5 field-label text-right-align"
              [class.required]="isFieldRequired('totalOutput')">
              {{
                (showConnectedLoadLabel ? 'technician-data.form-fields.connected-load' : 'technician-data.form-fields.total-output')
                  | translate
              }}
            </label>
            <input
              [appNumber]="true"
              class="ui-input pInputText small-width"
              formControlName="totalOutput"
              id="power-connection-total-output"
              maxlength="5"
              pInputText
              size="30"
              [readonly]="!powerConnectionSection.isDataEditable || isTotalOutputReadOnly" />
            <span class="field-unit-label">{{ unitLabels.power }}</span>
          </div>
          <div class="field-rows" *ngIf="powerConnectionFG.get('requiredFusePower')">
            <label class="field-label text-right-align required" for="power-connection-fuse-power">
              {{ 'technician-data.form-fields.swkn-required-fuse-power' | translate }}
            </label>
            <p-dropdown
              [options]="requiredFusePowerTypes"
              [readonly]="!powerConnectionSection.isDataEditable"
              formControlName="requiredFusePower"
              id="power-connection-fuse-power"
              placeholder="-Select-">
              <ng-template let-item pTemplate="selectedItem">
                <span class="drop-item-label">
                  {{ 'lookup.' + requiredFusePowerTypeKey + '.options.' + item['value'] + '.name' | translate }}
                </span>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="drop-item">
                  <span class="drop-item-label">
                    {{ 'lookup.' + requiredFusePowerTypeKey + '.options.' + option['value'] + '.name' | translate }}
                  </span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div
            *ngIf="showInfoTextRequiredFusePowerLarger200A"
            class="max-fuse-power-info-text"
            [innerHTML]="'technical-data.required-fuse-power-larger-200a' | translate"></div>
          <div class="ui-g-6 field-rows padding-left-1" *ngIf="showStandardPowerWarning || showInfoForCommodities">
            <span [innerHTML]="'technician-data.standard-power-warning' | translate"></span>
          </div>
        </div>
        <div *ngIf="powerConnectionFG.get('craneAvailable')" class="ui-g-12 form-rows">
          <div class="ui-g-6 field-rows">
            <label class="ui-g-5 field-label text-right-align required mr-3">
              {{ 'technician-data.form-fields.crane-available' | translate }}
            </label>
            <span class="ui-g-3 available-radio-buttons">
              <p-radioButton
                formControlName="craneAvailable"
                label="{{ 'yes-button-label' | translate }}"
                name="craneAvailable"
                [value]="true"></p-radioButton>
              <p-radioButton
                formControlName="craneAvailable"
                label="{{ 'no-button-label' | translate }}"
                name="craneAvailable"
                [value]="false"></p-radioButton>
            </span>
          </div>
        </div>

        <ng-container *ngIf="showPowerConnectionExtendendOptionsForNewMains">
          <div *ngIf="showPowerHouseConnectionLocationOptionsForNewMains" class="ui-g-12 form-rows field-rows">
            <div class="ui-g-12 field-rows radio-button-group">
              <label class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows required mr-3">
                {{ 'technician-data.form-fields.house-connection-installation-location.title' | translate }}
              </label>
              <label *ngIf="shouldShowWarningInfo" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows mr-3 warning">
                <span class="warning-icon">⚠️</span>
                {{ 'technician-data.form-fields.house-connection-installation-location.reminder-info' | translate }}
              </label>
              <div *ngFor="let item of installationLocationTypes" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <p-radioButton
                  formControlName="installationLocationType"
                  label="{{ item.label }}"
                  name="installationLocationType"
                  [value]="item.value"
                  [disabled]="!powerConnectionSection.isDataEditable"
                  (onClick)="onPowerConnectionLocationChange.emit(item.value)"></p-radioButton>

                <input
                  *ngIf="item.value.toLowerCase() === 'other'"
                  class="ui-input pInputText small-width"
                  formControlName="installationLocationTypeOther"
                  id="installationLocationTypeOther"
                  maxlength="30"
                  pInputText
                  size="30"
                  [readonly]="
                    !powerConnectionSection.isDataEditable || powerConnectionFG.value.installationLocationType?.toLowerCase() !== 'other'
                  " />
              </div>
            </div>
          </div>

          <div class="ui-g-12 form-rows">
            <div class="ui-g-6 field-rows">
              <label class="ui-g-5 field-label required mr-3">
                {{ 'technician-data.form-fields.offer-for-earthworks-on-private-property' | translate }}
              </label>
              <span class="ui-g-3 available-radio-buttons">
                <p-radioButton
                  formControlName="offerEarthworksOnPrivateProperty"
                  label="{{ 'yes-button-label' | translate }}"
                  name="offerEarthworksOnPrivateProperty"
                  [value]="true"
                  [disabled]="!powerConnectionSection.isDataEditable"></p-radioButton>
                <p-radioButton
                  formControlName="offerEarthworksOnPrivateProperty"
                  label="{{ 'no-button-label' | translate }}"
                  name="offerEarthworksOnPrivateProperty"
                  [value]="false"
                  [disabled]="!powerConnectionSection.isDataEditable"></p-radioButton>
              </span>
            </div>
            <div *ngIf="this.powerConnectionFG.get('offerEarthworksOnPrivateProperty').value" class="ui-g-8 field-rows">
              <label *ngIf="environmentService.showTechnicianDataEarthWorkArea" class="ui-g-7 field-label text-right-align required">
                {{ 'technician-data.form-fields.earthwork-area-name' | translate }}
              </label>
              <p-dropdown
                *ngIf="environmentService.showTechnicianDataEarthWorkArea"
                class="mr-3"
                [options]="earthworkAreaTypes"
                formControlName="earthworkAreaName"
                [readonly]="!powerConnectionSection.isDataEditable"
                id="earthwork-area-type"
                placeholder="-Select-">
                <ng-template let-item pTemplate="selectedItem">
                  <span class="drop-item-label">
                    {{ 'lookup.' + earthworkAreaKey + '.options.' + item['value'] + '.name' | translate }}
                  </span>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="drop-item">
                    <span class="drop-item-label">
                      {{ 'lookup.' + earthworkAreaKey + '.options.' + option['value'] + '.name' | translate }}
                    </span>
                  </div>
                </ng-template>
              </p-dropdown>
              <span [innerHTML]="'technician-data.offer-earthworks-info-text' | translate"></span>
            </div>
          </div>

          <div *ngIf="environmentService.showOtherCommoditiesForInstallation" class="ui-g-12 form-rows">
            <div class="ui-g-6 field-rows">
              <label class="ui-g-5 field-label mr-3">
                {{ 'technician-data.form-fields.other-commodities-for-installation.title' | translate }}
              </label>

              <div class="checkboxes-row">
                <p-checkbox
                  appEnterClick
                  formControlName="otherCommoditiesForInstallationGas"
                  [binary]="true"
                  label="{{ 'technician-data.form-fields.other-commodities-for-installation.gas' | translate }}"
                  [disabled]="!powerConnectionSection.isDataEditable"></p-checkbox>

                <p-checkbox
                  appEnterClick
                  formControlName="otherCommoditiesForInstallationHeating"
                  [binary]="true"
                  label="{{ 'technician-data.form-fields.other-commodities-for-installation.heating' | translate }}"
                  [disabled]="!powerConnectionSection.isDataEditable"></p-checkbox>

                <p-checkbox
                  appEnterClick
                  formControlName="otherCommoditiesForInstallationWater"
                  [binary]="true"
                  label="{{ 'technician-data.form-fields.other-commodities-for-installation.water' | translate }}"
                  [disabled]="!powerConnectionSection.isDataEditable"></p-checkbox>

                <p-checkbox
                  appEnterClick
                  formControlName="otherCommoditiesForInstallationOther"
                  [binary]="true"
                  label="{{ 'technician-data.form-fields.other-commodities-for-installation.other' | translate }}"
                  [disabled]="!powerConnectionSection.isDataEditable"></p-checkbox>
              </div>
            </div>

            <div *ngIf="powerConnectionFG.get('otherCommoditiesForInstallationOther')?.value" class="ui-g-6 other-input-container">
              <span class="p-float-label">
                <input
                  id="otherCommodityInput"
                  type="text"
                  maxlength="100"
                  pInputText
                  formControlName="otherCommoditiesForInstallationOtherInput"
                  [readonly]="!powerConnectionSection.isDataEditable || !powerConnectionFG.value.otherCommoditiesForInstallationOther" />
              </span>
            </div>
          </div>

          <div class="ui-g-12 form-rows field-rows">
            <div class="ui-g-12 field-rows radio-button-group">
              <label class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows required mr-3">
                {{ 'technician-data.form-fields.planned-type-of-heating.title' | translate }}
              </label>
              <div *ngFor="let item of powerConnectionHeatingTypes" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
                <p-radioButton
                  formControlName="powerConnectionHeatingType"
                  label="{{ item.label }}"
                  name="powerConnectionHeatingType"
                  [value]="item.value"
                  [disabled]="!powerConnectionSection.isDataEditable"></p-radioButton>

                <input
                  *ngIf="item.value.toLowerCase() === 'other'"
                  class="ui-input pInputText small-width"
                  formControlName="powerConnectionHeatingTypeOther"
                  id="powerConnectionHeatingTypeOther"
                  maxlength="30"
                  pInputText
                  size="30"
                  [readonly]="
                    !powerConnectionSection.isDataEditable || powerConnectionFG.value.powerConnectionHeatingType?.toLowerCase() !== 'other'
                  " />
              </div>
            </div>
          </div>
        </ng-container>

        <div *ngIf="powerConnectionFG.get('pumpAvailable')" class="ui-g-12 form-rows">
          <div class="ui-g-6 field-rows">
            <label class="ui-g-5 field-label text-right-align required mr-3">
              {{ 'technician-data.form-fields.pump-available' | translate }}
            </label>
            <span class="ui-g-3 available-radio-buttons">
              <p-radioButton
                formControlName="pumpAvailable"
                label="{{ 'yes-button-label' | translate }}"
                name="pumpAvailable"
                [value]="true"></p-radioButton>
              <p-radioButton
                formControlName="pumpAvailable"
                label="{{ 'no-button-label' | translate }}"
                name="pumpAvailable"
                [value]="false"></p-radioButton>
            </span>
          </div>
        </div>

        <div *ngIf="showSpecialConsumers">
          <ng-container *ngFor="let value of specialDeviceCount">
            <app-special-consumers
              (deleteComponent)="removeChildElements($event)"
              [isReadOnly]="!powerConnectionSection.isDataEditable"
              [specialDeviceData]="specialDeviceData[value]"></app-special-consumers>
          </ng-container>
          <div class="ui-g-12 add-button-row" *ngIf="powerConnectionSection.isDataEditable && showAddPowerDeviceButton">
            <i (click)="addSpecialDevice()" class="pi pi-plus plus-icon" id="power-connection-add-consumer" tabindex="0" appEnterClick></i>
            <label class="ui-g-5 field-label" for="power-connection-add-consumer">
              {{ 'technician-data.form-fields.special-consumers-button' | translate }}
            </label>
          </div>
        </div>
      </div>
    </app-review-section>
    <app-review-section
      *ngIf="showTempConnectionRegistrationForNewMains"
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align"
      [showAcceptRejectButtons]="false"
      [title]="'technician-data.form-fields.registration-temp-connection-title' | translate"
      [tooltip]="'tooltips.technician-form.registration-temp-connection-tooltip' | translate"
      [showTooltip]="true">
      <div class="form-background form-section">
        <div class="ui-g-12 form-rows">
          <div class="ui-g-12 field-rows">
            <p-checkbox
              appEnterClick
              formControlName="requiredTempConnectionLess30"
              binary="true"
              name="required-temp-connection-less30"
              label="{{ 'technician-data.form-fields.temp-power-connection-less30' | translate }}"></p-checkbox>
          </div>
        </div>
        <div class="ui-g-12 form-rows" *ngIf="powerConnectionFG.get('requiredTempConnectionLess30').value">
          <div class="ui-g-8 field-rows">
            <label for="technician-bdew-id" class="field-label text-right-align required">
              {{ 'technician-data.form-fields.technician-bdew-id' | translate }}
            </label>
            <input
              class="ui-input pInputText small-width mr-3"
              formControlName="technicianBdewId"
              id="technician-bdew-id"
              maxlength="9"
              pInputText
              size="30"
              [readonly]="!powerConnectionSection.isDataEditable || isTechnician || this.powerConnectionData?.tempPowerReportConfirmed" />
            <div *ngIf="!powerConnectionFG.get('isTechnicianRegistered').value && isCustomer">
              {{ 'technician-data.form-fields.technician-not-registered' | translate }}
            </div>
            <div *ngIf="powerConnectionFG.get('isTechnicianRegistered').value && isCustomer">
              <input
                class="ui-input pInputText"
                [(ngModel)]="technicianName"
                [ngModelOptions]="{ standalone: true }"
                id="technician-name"
                pInputText
                size="30"
                readonly="true" />
            </div>
          </div>
          <div class="ui-g-4 field-rows" *ngIf="isCustomer">
            {{ 'technician-data.form-fields.no-bdew-id-message' | translate }}
          </div>
          <div class="ui-g-8 field-rows" *ngIf="isCustomer && environmentService.showPowerConnectionInfo2">
            <p-card>{{ 'basic-profile.jurisdiction.power-connection-type-info-2' | translate }}</p-card>
          </div>
        </div>
      </div>
    </app-review-section>
    <ng-container
      *ngIf="
        showTempPowerReportConfirmationForNewMains &&
        powerConnectionFG.get('requiredTempConnectionLess30')?.value &&
        powerConnectionFG.get('tempPowerReportConfirmed')
      ">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-section-header [title]="'technician-data.form-fields.temp-power-connection-report-title' | translate"></app-section-header>
      </div>
      <div class="form-background form-section">
        <div class="ui-g-12 form-rows">
          <div class="ui-g-12 field-rows">
            <p-checkbox
              appEnterClick
              class="required"
              binary="true"
              formControlName="tempPowerReportConfirmed"
              name="temp-power-connection-confirmation"
              label="{{ 'technician-data.form-fields.temp-power-connection-confirmation' | translate }}"></p-checkbox>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</div>
